var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4986 4.217L3.76859 11.054C2.55859 11.54 2.56559 12.215 3.54659 12.516L8.09859 13.936L18.6306 7.291C19.1286 6.988 19.5836 7.151 19.2096 7.483L10.6766 15.184H10.6746L10.6766 15.185L10.3626 19.877C10.8226 19.877 11.0256 19.666 11.2836 19.417L13.4946 17.267L18.0936 20.664C18.9416 21.131 19.5506 20.891 19.7616 19.879L22.7806 5.651C23.0896 4.412 22.3076 3.851 21.4986 4.217Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.a31d07f133d4e5399d4d862280f2aa95.svg";
export { ForwardRef as ReactComponent };